<div class="my-bus-page" [class.is-dialog]="isDialog">
  @if (isDialog) {
  <div class="dialog-header d-flex justify-content-between align-items-center mb-2">
    <h2 class="m-0 dialog-title">{{'FORM.DRIVE_VEHICLE' | transloco}}:</h2>
    @if (!data?.mandatory) {
    <button mat-icon-button (click)="closeModal()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
    }
  </div>
  } @else {
  <h2 class="mb-3">{{'FORM.DRIVE_VEHICLE' | transloco}}:</h2>
  }

  @if (loading) {
  <div class="my-3">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
  } @else {
  <div class="bus-radio-group">
    <div class="bus-radio-row" [class.selected]="selectedValue === noneValue" (click)="onSelect(noneValue)">
      <span class="bus-name">Nothing</span>
      <div class="checkbox-wrapper">
        <mat-checkbox [checked]="selectedValue === noneValue" [disabled]="saving"
          (click)="$event.stopPropagation(); onSelect(noneValue)">
        </mat-checkbox>
      </div>
      <div class="driver-container"></div>
    </div>
    @for (bus of buses; track bus.busId) {
    <div class="bus-radio-row" [class.selected]="selectedValue === bus.busId" (click)="onSelect(bus.busId)">
      <span class="bus-name" [title]="bus.name">{{ bus.name }}</span>
      <div class="checkbox-wrapper">
        <mat-checkbox [checked]="selectedValue === bus.busId" [disabled]="saving"
          (click)="$event.stopPropagation(); onSelect(bus.busId)">
        </mat-checkbox>
      </div>
      <div class="driver-container">
        @if (bus.currentDriverName) {
        <span class="driver-badge" [title]="bus.currentDriverName">
          <mat-icon class="driver-icon">person</mat-icon>
          <span class="driver-name">{{ bus.currentDriverName }}</span>
        </span>
        }
      </div>
    </div>
    }
  </div>

  @if (isDialog) {
  <div class="dialog-actions d-flex justify-content-end gap-2 pt-2">
    @if (!data?.mandatory) {
    <button mat-stroked-button (click)="closeModal()" [disabled]="saving">{{'PARKING_EDIT.CANCEL' | transloco}}</button>
    }
    <button mat-raised-button color="primary" (click)="onConfirm()" [disabled]="saving">
      {{'PARKING_EDIT.SAVE' | transloco}}
    </button>
  </div>
  }
  }
</div>